import {
  RETRIEVE_STUDENT_LIST,
  RETRIEVE_MASTER_STUDENT_LIST,
  CREATE_STUDENT,
  GET_STUDENT_INFO,
  EDIT_STUDENT,
  DELETE_STUDENT,
  IMPORT_STUDENTS,
  RETRIEVE_SAMPLE_STUDENT_FILE,
  EXPORT_STUDENTS,
  EXPORT_QR_STUDENTS
} from '@/api'

import {ON_SHOWED_NEW_STUDENT, LIST_STUDENT_NEW } from '@/api/phase2/parentApprove'

export default {
  retrieveStudentList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_STUDENT_LIST(payload, successCallback, errorCallback)
  },

  retrieveMasterStudentList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_MASTER_STUDENT_LIST(payload, successCallback, errorCallback)
  },

  createStudent(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.student_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_STUDENT({data: payload.data}, successCallback, errorCallback)
  },

  editStudent({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.student_info) {
        commit('getStudentInfo', {studentInfo: response.data.data.student_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_STUDENT({data: payload}, successCallback, errorCallback)
  },

  getStudentInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.student_info) {
        commit('getStudentInfo', {studentInfo: response.data.data.student_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_STUDENT_INFO({payload}, successCallback, errorCallback)
  },

  deleteStudent(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_STUDENT({payload}, successCallback, errorCallback)
  },

  goToPage({commit}, payload) {
    commit('goToPage', {payload: payload})
  },

  deleteStudentInParent({commit}, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_STUDENT({payload}, successCallback, errorCallback)
  },

  importStudents({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    };

    IMPORT_STUDENTS(payload, successCallback, errorCallback)
  },

  retrieveSampleParentFile(store, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_SAMPLE_STUDENT_FILE(successCallback, errorCallback)
  },

  exportStudents(store, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    EXPORT_STUDENTS(successCallback, errorCallback)
  },

  exportQrStudents (store, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    EXPORT_QR_STUDENTS(successCallback, errorCallback)
  },

  getListNewStudent ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    LIST_STUDENT_NEW({ payload }, successCallback, errorCallback)
  },
  onShowStudentNew ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    ON_SHOWED_NEW_STUDENT({ payload }, successCallback, errorCallback)
  }
};
